export const JitsiMeet = window.JitsiMeetJS